import type { AuthChangeEvent, Session } from "@supabase/supabase-js";

export interface AuthSessionSignal {
  event: AuthChangeEvent;
  session: Session | null;
  sequence: number;
}

export interface AuthSessionSignalAction {
  event: AuthChangeEvent;
  session: Session | null;
}

export type RoleLoadMode = "blocking" | "background" | "none";

export function authSessionSignalReducer(
  state: AuthSessionSignal | null,
  action: AuthSessionSignalAction
): AuthSessionSignal | null {
  return {
    event: action.event,
    session: action.session,
    sequence: (state?.sequence ?? 0) + 1,
  };
}

/**
 * Role reads are an effect of an auth event, never work performed inside the
 * Supabase callback itself. Same-user foreground/token events keep the last
 * verified authorization and therefore cannot replace the working surface with
 * the initial role gate.
 */
export function roleLoadModeForAuthEvent(
  event: AuthChangeEvent,
  previousUserId: string | null,
  nextUserId: string | null
): RoleLoadMode {
  if (!nextUserId) return "none";
  if (previousUserId !== nextUserId) return "blocking";
  if (event === "SIGNED_IN" || event === "USER_UPDATED") return "background";
  return "none";
}
